import React from 'react';

import { Settings } from 'src/features/administration//utils/types';

const SettingsContext = React.createContext<Settings>({
    languages: [],
    default_language: 'en',
});

export default SettingsContext;
